export interface CompanyConfig{
    appName: string;
    hostUrl: string;
    companyName: string;
    address: string;
    contactInfo: string;
    logoUrl?: string;
    primaryColor?: string;
    accentColor?: string;
}
export const COMPANY_CONFIG: CompanyConfig = {
  appName: 'Aveespa Portal',
  hostUrl: 'https://localhost:4200',
  companyName: 'Aveespa Solutions',
  address: '457 E Pine St, Altadena, CA 91001',
  contactInfo: 'support@aveespa.com',
  logoUrl: 'images/logo/logo-text-on-dark.png',
  primaryColor: '#1f2035',
  accentColor: '#ffb000'
}